var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / credit-card-front"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75732H4C2.897 3.75732 2 4.65432 2 5.75732V17.7573C2 18.8603 2.897 19.7573 4 19.7573H20C21.103 19.7573 22 18.8603 22 17.7573V5.75732C22 4.65432 21.103 3.75732 20 3.75732ZM4 17.7573V5.75732H20L20.001 17.7573H4Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.7573H9.5C9.63261 10.7573 9.75979 10.7046 9.85355 10.6109C9.94732 10.5171 10 10.3899 10 10.2573V8.25732C10 8.12472 9.94732 7.99754 9.85355 7.90377C9.75979 7.81 9.63261 7.75732 9.5 7.75732H6.5C6.36739 7.75732 6.24021 7.81 6.14645 7.90377C6.05268 7.99754 6 8.12472 6 8.25732V10.2573C6 10.3899 6.05268 10.5171 6.14645 10.6109C6.24021 10.7046 6.36739 10.7573 6.5 10.7573ZM6 13.7573H12V15.7583H6V13.7573ZM13 13.7573H18V15.7583H13V13.7573Z",
    fill: "#292829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.9377be6468fd7c2f382018c5a89ab15b.svg";
export { ForwardRef as ReactComponent };